"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const TableRow_1 = tslib_1.__importDefault(require("@mui/material/TableRow"));
const TableSimpleHeaderCell_1 = tslib_1.__importDefault(require("../TableSimpleCells/TableSimpleHeaderCell"));
/**
 *
 * @category component
 */
const TableSimpleHeader = ({ columns, ...rest }) => {
    return (react_1.default.createElement(TableRow_1.default, { ...rest }, columns?.map((column) => react_1.default.createElement(TableSimpleHeaderCell_1.default, { key: column.columnId, ...column }))));
};
exports.default = TableSimpleHeader;
